export type ResolvedFlyerCaptureMode = string | null;

function normalizeMode(value: unknown): ResolvedFlyerCaptureMode {
  if (typeof value !== "string") return null;
  const normalized = value.trim().toUpperCase();
  if (!normalized) return null;
  if (normalized === "UPLOAD") return null;
  if (normalized === "DOWNLOAD") return "DOWNLOAD_ONLY";
  if (normalized === "DOWNLOAD_ONLY") return "DOWNLOAD_ONLY";
  if (normalized === "IMAGE_CAPTURE") return "IMAGE_CAPTURE";
  return normalized;
}

/**
 * Resolve flyer capture mode from batch config.
 * Important: missing mode must stay null so legacy/upload runs are not
 * misclassified as DOWNLOAD_ONLY in the Steps UI.
 */
export function resolveFlyerCaptureMode(
  currentConfig?: Record<string, unknown> | null,
): ResolvedFlyerCaptureMode {
  const flyerExtraction = currentConfig?.flyerExtraction as Record<string, unknown> | undefined;
  const scanOverrides = currentConfig?.scan_overrides as Record<string, unknown> | undefined;
  const topLevelCaptureTypeRaw = currentConfig?.flyerCaptureType;
  const topLevelCaptureType = normalizeMode(topLevelCaptureTypeRaw);
  const hasTopLevelCaptureType = typeof topLevelCaptureTypeRaw === "string" && topLevelCaptureTypeRaw.trim().length > 0;

  // Top-level wizard capture type is the most reliable intent signal.
  if (hasTopLevelCaptureType) {
    return topLevelCaptureType;
  }

  const mode = normalizeMode(
    (flyerExtraction?.flyerCaptureMode as string | null | undefined) ??
    (scanOverrides?.flyer_capture_mode as string | null | undefined) ??
    null,
  );

  return mode;
}
